import { ApplicationState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import ReportForm  from "../components/Forms/ReportForm";
import { ClientEntity, ReportEntity } from "../store/entities/state";
import { isSubmittingNew, getChangingValue, getChangingState } from "../store/entities/selectors";
import { createEntity, entityCreatingCancel, updateChangingEntity } from "../store/entities/actions";
import { ReportFormDispatchProps, ReportFormStateProps } from "../components/Forms/ReportForm";
import { createClientReportAsync } from "../ajax/requests";
import { getCompanyLogo } from "../store/settings/selectors";

const mapStateToProps = (state: ApplicationState): ReportFormStateProps => ({
    companyLogo: getCompanyLogo(state),
    report: getChangingValue(state, 'reports') as ReportEntity,
    hasChanged: getChangingState(state, 'reports'),
    loading: isSubmittingNew(state, 'reports'),
    readOnly: false,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch): ReportFormDispatchProps => ({
    onChange: (data: ReportEntity) => dispatch(updateChangingEntity('reports', data)),
    onClose: () => dispatch(entityCreatingCancel('reports')),
    onSubmit: (clientId: string, data: ReportEntity) => dispatch(createEntity('reports', data, r => createClientReportAsync(clientId, r))),
});

const ReportCreateForm = connect<ReportFormStateProps, ReportFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ReportForm as any);

export default ReportCreateForm;